import * as React from 'react';
import { IconChevronDownSmall16, IconChevronUpSmall16, Button, TCssFontWeight } from '@cian/ui-kit';
import * as styles from './SelectButton.css';

export interface ISelectButtonProps {
  open: boolean;
  text: string;
  counter: number;
  onClick?(): void;
  label?: string;
  fontWeight?: TCssFontWeight;
  fullWidth?: boolean;
  withArrow?: boolean;
  disabled?: boolean;
}

export const SelectButton = React.forwardRef<HTMLButtonElement, ISelectButtonProps>(function SelectButton(
  { open, text, counter, onClick, label, fontWeight, fullWidth, withArrow, disabled },
  ref,
) {
  const arrow = React.useMemo(() => {
    const color = disabled ? 'gray40_100' : 'primary_100';

    return open ? (
      <IconChevronUpSmall16 color={color} display="block" />
    ) : (
      <IconChevronDownSmall16 color={color} display="block" />
    );
  }, [open, disabled]);

  return (
    <Button
      disabled={disabled}
      aria-label={label}
      ref={ref}
      onClick={onClick}
      size="XS"
      theme="stroke_secondary"
      type="button"
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <span className={styles['content']}>
        <span className={styles['text']} style={{ fontWeight, maxWidth: fullWidth ? 'none' : 184 }}>
          {text}
        </span>
        {!!counter && <span className={styles['counter']}>{counter}</span>}
        {withArrow && <div className={styles['arrow']}>{arrow}</div>}
      </span>
    </Button>
  );
});
